import { render, staticRenderFns } from "./addStudent.vue?vue&type=template&id=2c6edf88&scoped=true&"
import script from "./addStudent.vue?vue&type=script&lang=js&"
export * from "./addStudent.vue?vue&type=script&lang=js&"
import style0 from "./addStudent.vue?vue&type=style&index=0&id=2c6edf88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6edf88",
  null
  
)

export default component.exports